export default "https://cdn-static.gokick.com/assets/0d39bc0fcec85c93d0d6a7d8f262b967dc26f977/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";